module.exports = __webpack_public_path__ + "static/media/StyleProfile-Lifestyle.61b66211.svg";